import { Skeleton } from "primereact/skeleton"

type Props = {
  subtitle?: boolean
  avatarSize?: number // size of the avatar in px because ProfileAvatar use px 💩
} & React.HTMLAttributes<HTMLDivElement>

/**
 * UserCell is a component that displays a user's avatar, name and subtitle
 * It's used in Datable components to display a user's information : avatar, name and username
 */
export const UserCellSkeleton: React.FC<Props> = ({ subtitle = false, avatarSize, ...props }) => {
  const defautlClassName = "flex gap-2 flex-row w-full"
  return (
    <div className={props.className ? props.className : defautlClassName} {...props}>
      <Skeleton shape="circle" size={avatarSize ? `${avatarSize}px` : "2.5rem"} />
      <div className="flex flex-column gap-1 justify-content-center">
        <Skeleton width="6rem" height="1rem" className="border-round-sm" />
        {subtitle && <Skeleton width="3rem" height="0.8rem" className="border-round-sm" />}
      </div>
    </div>
  )
}
